const state = () => ({
  isValid: false,
  firstName: '',
  lastName: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  firstName(state) {
    return state.firstName;
  },
  lastName(state) {
    return state.lastName;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateFirstName(state, payload) {
    state.firstName = payload;
  },
  updateLastName(state, payload) {
    state.lastName = payload;
  }
};

const actions = {
  updateFirstName({ commit }, payload) {
    commit('updateFirstName', payload);
  },
  updateLastName({ commit }, payload) {
    commit('updateLastName', payload);
  }
};

export const basicInfo = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
